export const iconFontAwesomeArrowsRotateLeft = (
	<i className="fa-solid fa-rotate-left"></i>
);
